<template>
<v-layout row>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <!--
      <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
      -->
      <v-btn color="pink" dark small fixed top right fab style="top:44px" v-on="on">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text class="pt-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                :items="['daejeon', 'test']"
                v-model="editedItem.group"
                label="group"
                single-line
                :disabled="!isAdmin"
                v-show="isAdmin"
                />
            </v-flex>
            <v-flex>
              근무 상태 (v1에서는 출근부 목록에만 적용 됩니다.)
              <v-radio-group
                v-model="editedItem.employmentStatus"
                :column="false">
                <v-radio label="근무" value="working"></v-radio>
                <v-radio label="휴직" value="leave"></v-radio>
                <v-radio label="퇴사" value="resigned"></v-radio>
                <v-radio label="입사 대기" value="pending"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="editedItem.name" label="점검자 이름" :disabled="!isAdmin"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="editedItem.phoneNumber" label="전화번호"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-menu
                v-model="birthDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editedItem.birthDate"
                    label="생년월일"
                    prepend-icon="event"
                    readonly
                    v-on="on"/>
                </template>
                <v-date-picker
                  v-model="editedItem.birthDate"
                  no-title
                  locale="ko"
                  :day-format="day => new Date(day).getDate()"
                  @input="birthDateMenu = false">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-menu
                v-model="hireDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editedItem.hireDate"
                    label="채용일자"
                    prepend-icon="event"
                    readonly
                    v-on="on"/>
                </template>
                <v-date-picker
                  v-model="editedItem.hireDate"
                  no-title
                  locale="ko"
                  :day-format="day => new Date(day).getDate()"
                  @input="hireDateMenu = false">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="editedItem.address" label="주소"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$_close">취소</v-btn>
        <v-btn color="blue darken-1" flat @click="$_save">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-flex xs12>
    <v-card>
      <v-data-table
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :headers="headers"
        :items="datas"
        :loading="loading">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td v-if="isAdmin">{{ props.item.group }}</td>
          <td class="text-xs-left">{{ $_getEmploymentStatusText(props.item.employmentStatus) }}</td>
          <td class="text-xs-left">{{ props.item.phoneNumber }}</td>
          <td class="text-xs-left">{{ props.item.birthDate }}</td>
          <td class="text-xs-left">{{ props.item.hireDate }}</td>
          <td class="text-xs-left">{{ props.item.address }}</td>
          <td class="justify-center layout px-0">
              <v-icon
                small
                class="mr-2"
                @click="$_editItem(props.item)"
              >
                edit
              </v-icon>
              <v-icon
                v-if="isAdmin"
                small
                @click="$_deleteItem(props.item)"
              >
                delete
              </v-icon>
            </td>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
  <!--
  <v-btn fixed dark fab bottom right color="pink"
    @click="$router.push({name:'CheckerAdd'})">
    <v-icon>add</v-icon>
  </v-btn>
  -->
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'

export default {
  name: 'HelloWorld',
  data () {
    return {
      datas: [],
      rowsPerPageItems: [10, 20, 50, 100, 200],
      pagination: {
        rowsPerPage: 200
      },
      dialog: false,
      editedIndex: -1,
      editedItem: {
        group: this.$store.state.session.group,
        name: '',
        phoneNumber: '',
        status: '',
        address: '',
        birthDate: '',
        hireDate: '',
        employmentStatus: ''
      },
      defaultItem: {
        group: this.$store.state.session.group,
        name: '',
        phoneNumber: '',
        status: '',
        address: '',
        birthDate: '',
        hireDate: '',
        employmentStatus: ''
      },
      loading: false,
      // items: [{ header: '점검자 목록' }]
      isAdmin: false,

      birthDateMenu: false,
      hireDateMenu: false
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '점검자 신규 등록' : '점검자 정보 수정'
    },
    headers () {
      if (this.isAdmin) {
        return [{text: '이름', values: 'name', sortable: false},
          {text: 'group', values: 'group', sortable: false},
          {text: '근무상태', values: 'employmentStatus', sortable: false},
          {text: '전화번호', values: 'phoneNumber', sortable: false},
          {text: '생년월일', values: 'birthDate', sortable: false},
          {text: '채용일자', values: 'hireDate', sortable: false},
          {text: '주소', values: 'address', sortable: false},
          {text: '관리', values: 'actions', sortable: false}]
      } else {
        return [{text: '이름', values: 'name', sortable: false},
          {text: '근무상태', values: 'employmentStatus', sortable: false},
          {text: '전화번호', values: 'phoneNumber', sortable: false},
          {text: '생년월일', values: 'birthDate', sortable: false},
          {text: '채용일자', values: 'hireDate', sortable: false},
          {text: '주소', values: 'address', sortable: false},
          {text: '관리', values: 'actions', sortable: false}]
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getCheckers()
    },
    dialog (val) {
      val || this.$_close()
    }
  },
  created () {
    this.isAdmin = this.$store.state.session.admin

    this.$emit('title', '점검자 관리')
    this.$_getCheckers()
  },
  methods: {
    $_getCheckers () {
      this.loading = true
      this.datas = []

      let query = this.$fs.collection('checkers')

      if (!this.$store.state.session.admin) {
        console.log('aaaa')
        query = query.where('group', '==', this.$store.state.session.group)
      }

      query
        .orderBy('name')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            this.datas.push(item)
            // this.datas.push({ divider: true, inset: false })
            // console.log(doc.data())
          })
          this.loading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.loading = false
        })
    },
    $_editItem (item) {
      // console.log('edit', item)

      // this.$router.push({name:'CheckerEdit', params:{'id':item.id, 'checker':item}})
      this.editedIndex = this.datas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    $_deleteItem (item) {
      if (item.placeRefs) {
        if (item.placeRefs.length > 0) {
          alert('해당 점검자는 충전소에 할당 되어 있습니다.\n점검자-충전소 구성에서 먼저 제거하세요.')
          return
        }
      }

      const index = this.datas.indexOf(item)
      const name = this.datas[index].name
      const checkerId = this.datas[index].id
      const inputCheckerName = prompt('해당 "' + name + '" 점검자를 정말 삭제하시겠습니까?\n해당 점검자 이름을 한번 더 정확하게 입력하세요.')

      if (name === inputCheckerName) {
        // TODO loading

        /*
        // 연결되어 있는 place 정보 같이 삭제...
        // transaction 을 사용하여 reference 가 실제 존재하지 않는 경우를 처리하려고 했으나
        // Every document read in a transaction must also be written. 오류 발생으로 원복함.
        // transaction 은 해당 문서가 있을 경우 read 후 반드시 write 를 해야 함.
        const placeRef = this.datas[index].placeRef
        const checkerRef = this.$fs.collection('checkers').doc(checkerId)
        let job = null

        if (placeRef) { // 장소 정보 참조가 있을 경우
          job = this.$fs.db().runTransaction(t => {
            return t.get(placeRef)
              .then(doc => {
                //console.log('transaction', doc, doc.data().chargerRefs)

                try {
                  if (doc.exists) {
                    t.update(placeRef, {'checkerRef': firebase.firestore.FieldValue.delete(),
                                  updated: firebase.firestore.FieldValue.serverTimestamp()})
                  }

                  t.delete(checkerRef)
                  return Promise.resolve(doc)
                } catch (error) {
                  return Promise.reject(error)
                }
              })
          })
        } else {
          job = checkerRef.delete()
        }
        */

        this.$fs
          .collection('checkers')
          .doc(checkerId)
          .delete()
          .then(() => {
            // 로컬 데이터 업데이트
            this.datas.splice(index, 1)

            this.$emit('snackbar', '삭제되었습니다.')
            this.$_close()
          }).catch(error => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else if (inputCheckerName) {
        this.$emit('snackbar', '점검자 이름을 다시 확인하세요.')
      }
    },
    $_close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    $_save () {
      if (this.editedIndex > -1) { // 수정
        // TODO loading
        const item = this.datas[this.editedIndex]
        const checkerId = item.id
        const group = item.group

        if (group !== this.editedItem.group) {
          if (item.placeRefs) {
            if (item.placeRefs.length > 0) {
              alert('해당 점검자는 충전소에 할당 되어 있습니다.\n그룹 변경을 위해서 점검자-충전소 구성에서 먼저 제거하세요.')
              return
            }
          }
        }

        this.$fs.collection('checkers')
          .doc(checkerId)
          .set(
            {
              group: this.editedItem.group,
              name: this.editedItem.name,
              phoneNumber: this.editedItem.phoneNumber,
              address: this.editedItem.address,
              birthDate: this.editedItem.birthDate || '',
              hireDate: this.editedItem.hireDate || '',
              employmentStatus: this.editedItem.employmentStatus || '',
              updated: firebase.firestore.FieldValue.serverTimestamp()
            },
            {merge: true}
          )
          .then(() => {
            // 로컬 데이터 업데이트
            Object.assign(this.datas[this.editedIndex], this.editedItem)

            this.$emit('snackbar', '수정되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else { // 신규
        // TODO loading
        // 서버 데이터 업데이트
        this.$fs.collection('checkers')
          .add(Object.assign({created: firebase.firestore.FieldValue.serverTimestamp()}, this.editedItem))
          .then(() => {
            // 로컬 데이터 업데이트
            this.datas.push(this.editedItem)

            this.$emit('snackbar', '등록되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      }
    },
    $_getEmploymentStatusText (employmentStatus) {
      switch (employmentStatus) {
        case 'working': return '근무'
        case 'leave': return '휴직'
        case 'resigned': return '퇴사'
        case 'pending': return '입사 대기'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Checker/CheckerList.vue